<template>
  <div class="item-inner">
    <div class="item-title label" v-if="attribute.sorteditAble === false" style="width: 60%; color: #8e8e93;" >{{this.attribute.label}}</div>
    <div class="item-title label" v-else style="width: 60%;">{{this.attribute.label}}</div>
    <div class="item-input">
      <input type="text"  placeholder="请填写"  v-if="attribute.sorteditAble === false"  :value='attribute.value' disabled="disabled" >
      <input type="text"   @input="control"  placeholder="请填写"   v-else   v-model="attribute.value">
    </div>
  </div>
</template>

<script>
//  import $ from 'jquery'
  export default {
    name: 'attr-text-box',
    data () {
      return {
      }
    },
    props: [
      'attribute', 'index', 'curAttrsInGroup'
    ],
    mounted () {
    },
    created () {

    },
    computed: {
    },
    methods: {
      control () {
        this.$emit('controlForm', this.index, this.curAttrsInGroup)
      }
    },
    watch: {
      'attribute.value': function (val) {
        this.attribute.valueText = val
      }
    }
  }
</script>

<style scoped>
  input {
    border: 1px solid #ccc;
    outline: 0;
    transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
  }
  .error input {
    border-color: rgba(246, 58, 56, .8);
    box-shadow: 0 0 8px rgba(246, 58, 56, .6);
  }

</style>



// WEBPACK FOOTER //
// AttrTextBox.vue?66a1de16